/* ============================================================
   Cleanly — the theme's sticky add-to-cart bar.

   That bar normally submits the native product form, but on a bundle
   page the bundle selector replaces the native buy buttons, so the bar
   did nothing. Here we take the click over and add OFFER 1 (the single
   product of the page — exactly what the bar advertises) to the cart,
   then open the drawer, the same way the bundle CTA does.

   Sold out: offer 1 may carry "available": false. Then the bar shows
   אזל מהמלאי instead of adding. Never a blocking alert().

   Only active on pages that actually contain a bundle. Anywhere else the
   theme's own handler keeps working untouched.
   ============================================================ */
(function () {
  var SOLD_OUT = 'אזל מהמלאי';
  var GENERIC_ERR = 'אירעה שגיאה, נסו שוב';

  function offerOne() {
    var root = document.querySelector('[data-cl-bundle]');
    if (!root) return null;
    var el = root.querySelector('[data-bundle-config]');
    if (!el) return null;
    try {
      var c = JSON.parse(el.textContent);
      var o = (c.offers || [])[0];
      return o ? { key: c.key || 'bundle', offer: o } : null;
    } catch (e) { return null; }
  }

  /* Swap the bar label for a short message, then put it back. */
  function flash(btn, msg) {
    if (btn.__clHTML == null) btn.__clHTML = btn.innerHTML;
    if (btn.__clTimer) clearTimeout(btn.__clTimer);
    btn.innerHTML = '<span>' + msg + '</span>';
    btn.classList.add('is-soldout');
    btn.__clTimer = setTimeout(function () {
      btn.innerHTML = btn.__clHTML;
      btn.classList.remove('is-soldout');
      btn.__clTimer = null;
    }, 4000);
  }

  function add(btn) {
    var d = offerOne();
    if (!d) return;
    if (d.offer.available === false) { flash(btn, SOLD_OUT); return; }
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');

    var props = { '_bundle': d.key + '-offer1' };
    if (d.offer.freeShipping) props['_ships_free'] = 'true';
    var items = (d.offer.items || []).map(function (it) {
      return { id: Number(it.id), quantity: it.qty || 1, properties: props };
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (r.ok) return r.json();
        var err = new Error('add failed');
        err.soldOut = r.status === 422;
        throw err;
      })
      .then(function () {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .catch(function () { return null; });
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'cl-sticky', data: { source: 'cl-sticky', itemCount: cart && cart.item_count } }
        }));
        var drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') { try { drawer.open(); } catch (e) {} }
        btn.removeAttribute('aria-busy');
      })
      .catch(function (err) {
        btn.removeAttribute('aria-busy');
        flash(btn, (err && err.soldOut) ? SOLD_OUT : GENERIC_ERR);
      });
  }

  // Capture phase so we run before the theme's own delegated handler.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('sticky-add-to-cart button');
    if (!btn) return;
    var oc = btn.getAttribute('on:click') || '';
    if (oc && oc.toLowerCase().indexOf('addtocart') === -1) return;
    if (!document.querySelector('[data-cl-bundle]')) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    add(btn);
  }, true);

  window.addEventListener('pageshow', function () {
    document.querySelectorAll('sticky-add-to-cart button[aria-busy="true"]').forEach(function (b) {
      b.removeAttribute('aria-busy');
    });
  });
})();
